import { View } from '@react-pdf/renderer';
import { CriticalAreaProps } from 'features/patient/patient-summary/components/displays/display-critical-areas';
import { BodyText, TableText } from './pdf-default-components';

export function PDFCriticalArea(props: CriticalAreaProps) {
  return (
    <View>
      <BodyText>{props.label}</BodyText>
      <View
        style={{
          borderRadius: 6,
          border: `3px solid ${props.color}`,
          padding: 12
        }}
      >
        <TableText>{props.areas.join(', ')}</TableText>
      </View>
    </View>
  );
}
